import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TextField, Box, MenuItem, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";

import useService from "../../../../../../../hooks/useService";
import { parseValue } from "../../../../../../ui library/helpers/functions";
import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

export function SelectAnswer({
  enumUrl = "",
  label,
  name,
  onChange,
  schema,
  value = "",
  placeholder,
  sx = {},
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const fieldOptionRepository = useService("repositories/field-option-repository");

  const type = schema?.type || schema?.[schema.expected_input]?.properties?.[name]?.type;

  useEffect(() => {
    const initOptions = async () => {
      try {
        setLoading(true);
        let queryString = "";

        if (schema?.expected_input) {
          const expectedInput = schema.expected_input;
          const selectedSchema = schema[expectedInput];
          const prop = Object.values(selectedSchema.properties || {})[0];
          queryString = prop.enum.split("?")[1];
        } else {
          queryString = enumUrl.split("?")[1];
        }

        const params = Object.fromEntries(new URLSearchParams(queryString));
        const resp = await fieldOptionRepository.query(params);
        setOptions((resp || []).map(({ key, value }) => ({ key, value })));
        setLoading(false);
      } catch (error) {
        console.error("Something went wrong fetching options", error);
        setOptions([]);
        setLoading(false);
      }
    };

    initOptions();
  }, [enumUrl, schema]);

  const handleChange = (e) => {
    const parsedValue = parseValue(e.target.value, type);
    onChange(name, parsedValue);
  };

  return (
    <Box mb={2}>
      <QuestionTitle label={label} sx={sharedStyles.label(isFocused)} />

      <TextField
        select
        fullWidth
        size="small"
        name={name}
        value={value ?? ""}
        variant="outlined"
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        sx={{ ...sharedStyles.textField, ...sx }}
        placeholder={placeholder}
        SelectProps={{
          IconComponent: KeyboardArrowDownIcon,
          MenuProps: { PaperProps: { sx: sharedStyles.selectMenuPaper } },
        }}
      >
        <MenuItem value="" disabled={loading} sx={sharedStyles.menuItem}>
          {loading ? <CircularProgress size={16} /> : "-- Selection --"}
        </MenuItem>

        {options.map((opt, idx) => (
          <MenuItem key={`${opt.key}-${idx}`} value={opt.key} sx={sharedStyles.menuItem}>
            {opt.value}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
